import { OptimisticMutationResolver } from '@urql/exchange-graphcache';
import { ProtectionPlan_ApplicationFragment, ProtectionPlan_ApplicationFragmentDoc, UpdateProtectionPlanMutationVariables } from '../../generated.graphql';


export const calcNewValues = (application: ProtectionPlan_ApplicationFragment, newValue: boolean) => {
  const disabling = application?.includesProtectionPlan === true && newValue === false
  const enabling = application?.includesProtectionPlan === false && newValue === true
  
  let diff = 0;
  if (enabling) diff = 
    diff = 0 + parseFloat(application.pricing.protectionPlan)
  else if (disabling) 
    diff = 0 - parseFloat(application.pricing.protectionPlan)

  return {
    protectionPlan: newValue,
    initialPayment: parseFloat(application.pricing.initialPayment) + diff,
    ongoingPayment: parseFloat(application.pricing.ongoingPayment) + diff,
  }
}

export const protectionPlanOptimisticResolver: OptimisticMutationResolver = (variables, cache, info) => {
  const { portalSlug, input: { protectionPlan } } = variables as UpdateProtectionPlanMutationVariables
  const application = cache.readFragment(ProtectionPlan_ApplicationFragmentDoc, {__typename: "Application", portal: {slug: portalSlug}}) as ProtectionPlan_ApplicationFragment | null
  if (application) {
    const newValues = {
      application: {
        ...application,
        ...calcNewValues(application, protectionPlan),
        __typename: "Application"
      },
      __typename: "UpdateProtectionPlanPayload"
    };
    return newValues;
  }
  return null;
}
